// Mock data for Fluxo Tech IA website

export const mockData = {
  company: {
    name: "Fluxo Tech IA",
    tagline: "IA Que Converte Contatos em Clientes 24/7",
    description: "A cada contato não atendido, você perde uma oportunidade. Nossa IA responde em segundos, qualifica automaticamente e agenda atendimentos enquanto você foca no que realmente importa: seu negócio.",
    logo: "https://customer-assets.emergentagent.com/job_ae3440fe-d2fd-47ab-8a0e-947efc201a74/artifacts/wfshn04g_Gemini_Generated_Image_ow3ynsow3ynsow3y.png"
  },
  
  contact: {
    whatsapp: "5514996005922",
    email: "contato@fluxotecia.com.br"
  },
  
  problem: {
    title: "O Custo da Demora no Atendimento",
    subtitle: "A 'Janela de Ouro' determina se você converte ou perde o cliente",
    issues: [
      {
        id: 1,
        problem: "Primeiros 5 Minutos",
        cost: "9x mais chances de conversão",
        icon: "Clock"
      },
      {
        id: 2,
        problem: "45% dos Contatos Fora do Horário",
        cost: "Geralmente são decisores ocupados (executivos, profissionais)",
        icon: "Moon"
      },
      {
        id: 3,
        problem: "Após 30 Minutos",
        cost: "Taxa de qualificação cai 21x",
        icon: "AlertCircle"
      },
      {
        id: 4,
        problem: "Após 12 Horas",
        cost: "Chance de conversão cai para menos de 5%",
        icon: "XCircle"
      }
    ]
  },
  
  speedToLead: {
    title: "A Janela de Ouro: Primeiros 5 Minutos Decidem Tudo",
    subtitle: "Dados de Harvard Business Review sobre tempo de resposta",
    description: "Não é que o contato 'fora do horário' seja ruim. Seu processo é que o torna ruim ao deixá-lo esperando. Muitas vezes, quem busca seu serviço à noite ou fim de semana são os decisores mais qualificados - pessoas ocupadas que só conseguem resolver assuntos pessoais após o expediente. Mas eles exigem resposta instantânea.",
    stats: [
      {
        time: "< 5 min",
        impact: "9x mais chances de conversão",
        description: "Cliente está com sua aba aberta, interesse 'fresco' na cabeça. É agora ou nunca.",
        color: "green"
      },
      {
        time: "30 min",
        impact: "Taxa de qualificação cai 21x",
        description: "Cliente já foi almoçar, entrou em reunião ou pesquisou seu concorrente.",
        color: "yellow"
      },
      {
        time: "12h+",
        impact: "Menos de 5% de chance",
        description: "Mesmo esforço de prospecção fria. O interesse 'evaporou' completamente.",
        color: "red"
      }
    ],
    comparison: {
      title: "Segunda-feira Sem Automação",
      problems: [
        "Equipe gasta 3 horas tentando contato com interessados do fim de semana que não atendem mais",
        "60% de desistência em contatos que esperaram mais de 24h por uma resposta",
        "Perde oportunidades quentes de segunda tentando recuperar os frios do fim de semana"
      ]
    }
  },
  
  trafficWaste: {
    title: "O Peso no Seu Time Sem Automação",
    subtitle: "Tarefas repetitivas consomem tempo que deveria ser usado para atender bem",
    description: "Sua equipe gasta horas respondendo as mesmas perguntas: horário, endereço, preço, disponibilidade. Enquanto isso, atendimentos que realmente precisam de atenção humana ficam esperando. Automação não substitui pessoas — libera elas para o que importa.",
    stats: [
      {
        icon: "Clock",
        value: "3h/dia",
        label: "Em Tarefas Repetitivas",
        sublabel: "Perguntas básicas que IA resolve em segundos"
      },
      {
        icon: "MessageSquare",
        value: "40%",
        label: "Mensagens São Iguais",
        sublabel: "Horário, preço, endereço, disponibilidade"
      },
      {
        icon: "AlertCircle",
        value: "+35%",
        label: "Mais Erros Humanos",
        sublabel: "Sobrecarga gera falhas, atrasos e insatisfação"
      },
      {
        icon: "XCircle",
        value: "Zero",
        label: "Dados Organizados",
        sublabel: "Informações perdidas em conversas sem registro"
      }
    ]
  },
  
  services: [
    {
      id: 1,
      title: "IA Conversacional Avançada",
      description: "Diferente de chatbots básicos com menus limitados, nossa IA entende contexto, responde naturalmente e resolve problemas reais. Tecnologia que conversa como humano, não como robô.",
      icon: "Zap",
      tag: "IA AVANÇADA"
    },
    {
      id: 2,
      title: "Disponibilidade Total",
      description: "Atendimento 24 horas por dia, 7 dias por semana. Madrugada, fim de semana ou feriado - todos os contatos recebem resposta imediata. Nunca perca uma oportunidade por indisponibilidade.",
      icon: "Clock",
      tag: "24/7/365"
    },
    {
      id: 3,
      title: "Qualificação Inteligente",
      description: "A IA identifica automaticamente intenção, urgência e perfil do cliente. Sua equipe recebe apenas contatos qualificados e prontos para conversão, economizando tempo valioso.",
      icon: "Target",
      tag: "AUTO-QUALIFICAÇÃO"
    },
    {
      id: 4,
      title: "Implementação Simplificada",
      description: "Solução 100% gerenciada. Configuramos, treinamos a IA com seus dados e entregamos pronto para usar. Você não precisa entender tecnologia, apenas ver os resultados.",
      icon: "Sparkles",
      tag: "PLUG & PLAY"
    }
  ],
  
  useCases: [
    {
      id: 1,
      industry: "Imobiliárias",
      title: "Aumente Conversões em Até 300%",
      description: "Imobiliária com 50 leads mensais aumentou taxa de agendamento de 20% para 65% com resposta instantânea e qualificação automática.",
      benefits: [
        "Resposta instantânea a qualquer horário",
        "Qualificação automática por perfil e renda",
        "Agendamento de visitas sem intervenção humana",
        "Follow-up inteligente até conversão"
      ],
      roi: "💰 ROI médio de 15x em 30 dias",
      icon: "Home"
    },
    {
      id: 2,
      industry: "Clínicas e Consultórios",
      title: "Reduza Faltas em Até 40%",
      description: "Clínica odontológica reduziu no-show de 28% para 12% com confirmações automáticas e lembretes estratégicos.",
      benefits: [
        "Confirmação automática 24h antes",
        "Lembretes estratégicos por WhatsApp",
        "Reagendamento instantâneo de cancelamentos",
        "Atendimento 24/7 para novos agendamentos"
      ],
      roi: "💰 Payback em 7-10 dias",
      icon: "Heart"
    },
    {
      id: 3,
      industry: "Restaurantes",
      title: "Automatize Reservas e Pedidos",
      description: "Restaurante aumentou capacidade de atendimento em 40% automatizando reservas e pedidos delivery via WhatsApp.",
      benefits: [
        "Recebe pedidos 24/7 mesmo fora do horário",
        "Confirmação automática de reservas",
        "Sugere pratos e combos baseado em histórico",
        "Reduz erro humano em pedidos"
      ],
      roi: "💰 +35% em receita mensal",
      icon: "Utensils"
    },
    {
      id: 4,
      industry: "Academias",
      title: "Retenção de Alunos +45%",
      description: "Academia fitness reduziu cancelamentos com check-ins automáticos, lembretes de treino e acompanhamento personalizado.",
      benefits: [
        "Lembrete de treinos agendados",
        "Acompanhamento de progresso automático",
        "Reengajamento de alunos inativos",
        "Renovação automática de planos"
      ],
      roi: "💰 Retenção aumentou 45%",
      icon: "Dumbbell"
    },
    {
      id: 5,
      industry: "Escritórios Contábeis",
      title: "Qualificação de Leads +280%",
      description: "Escritório contábil triplicou leads qualificados com IA que identifica porte da empresa e necessidades antes do primeiro contato.",
      benefits: [
        "Qualifica porte e faturamento automaticamente",
        "Agenda reuniões apenas com leads quentes",
        "Envia materiais personalizados por segmento",
        "Libera time comercial para fechamento"
      ],
      roi: "💰 280% mais leads qualificados",
      icon: "Calculator"
    },
    {
      id: 6,
      industry: "Salões de Beleza",
      title: "Agenda Sempre Cheia",
      description: "Salão aumentou ocupação de 65% para 92% com agendamento automatizado e confirmações que reduzem faltas.",
      benefits: [
        "Agendamento 24/7 por WhatsApp",
        "Confirmação automática reduz faltas",
        "Oferece horários alternativos automaticamente",
        "Envia promoções personalizadas"
      ],
      roi: "💰 +27 pontos de ocupação",
      icon: "Scissors"
    }
  ],
  
  about: {
    title: "Tecnologia para Negócios Locais",
    description: "Trazemos soluções de IA de nível corporativo, adaptadas e acessíveis para empresas em crescimento. Implementação completa e gestão contínua sem complexidade técnica.",
    differentials: [
      {
        title: "Tecnologia Democratizada",
        description: "Acesso à IA avançada não precisa ser privilégio de grandes corporações. Oferecemos a ponte entre tecnologia de ponta e negócios em crescimento, com implementação descomplicada.",
        icon: "Sparkles"
      },
      {
        title: "Momento Estratégico",
        description: "O mercado de IA para negócios locais está em expansão inicial. Empresas que adotam agora constroem vantagem competitiva sustentável antes da saturação do mercado.",
        icon: "Zap"
      },
      {
        title: "Foco em Resultados",
        description: "Você não precisa ser especialista em IA ou tecnologia. Cuidamos de toda implementação, treinamento e gestão. Seu foco permanece onde deve estar: no seu core business.",
        icon: "Target"
      },
      {
        title: "Sem Sobrecarga",
        description: "Sua equipe foca no que realmente importa. IA cuida da triagem, qualificação e agendamentos repetitivos. Mais tempo para atender bem, menos tempo em tarefas operacionais.",
        icon: "Award"
      }
    ],
    stats: [
      { value: "90%+", label: "Redução de Tempo Operacional" },
      { value: "24/7", label: "Disponibilidade" },
      { value: "Implementação Completa", label: "Em Menos de 7 dias" }
    ]
  },
  
  cta: {
    title: "Pronto Para Escalar Seu Atendimento?",
    subtitle: "Agende uma demonstração gratuita e descubra o potencial de conversão da sua operação com IA. Análise personalizada do seu cenário em 15 minutos.",
    buttonText: "Agendar Demonstração Gratuita",
    urgency: "⚡ Vagas limitadas: 5 implementações por mês para garantir qualidade",
    guarantee: "🎯 Implemente esta semana e tenha suporte dedicado durante todo o período"
  },
  
  quiz: {
    title: "Seu Negócio Está Perdendo Oportunidades?",
    subtitle: "Responda 5 perguntas rápidas e descubra o potencial de melhoria",
    questions: [
      {
        id: 1,
        question: "Quanto tempo em média seu cliente espera por uma resposta no WhatsApp?",
        options: [
          { text: "Menos de 5 minutos", points: 1 },
          { text: "5 a 30 minutos", points: 2 },
          { text: "30 minutos a 2 horas", points: 3 },
          { text: "Mais de 2 horas ou no dia seguinte", points: 4 }
        ]
      },
      {
        id: 2,
        question: "Você perde oportunidades fora do horário comercial?",
        options: [
          { text: "Não, atendemos 24/7", points: 1 },
          { text: "Raramente, poucos leads chegam fora do horário", points: 2 },
          { text: "Sim, mas conseguimos responder no dia seguinte", points: 3 },
          { text: "Sim, muitos leads chegam de noite/fim de semana", points: 4 }
        ]
      },
      {
        id: 3,
        question: "Como você qualifica leads antes de atender?",
        options: [
          { text: "Temos processo automatizado de qualificação", points: 1 },
          { text: "Equipe faz perguntas básicas manualmente", points: 2 },
          { text: "Atendemos todos e descobrimos depois", points: 3 },
          { text: "Não qualificamos, perdemos muito tempo", points: 4 }
        ]
      },
      {
        id: 4,
        question: "Quantos leads você estima que não recebem resposta ou demoram muito?",
        options: [
          { text: "Quase nenhum, atendemos todos rápido", points: 1 },
          { text: "Menos de 10%", points: 2 },
          { text: "Entre 10% e 30%", points: 3 },
          { text: "Mais de 30%", points: 4 }
        ]
      },
      {
        id: 5,
        question: "Sua equipe consegue lidar com picos de demanda?",
        options: [
          { text: "Sim, temos capacidade de sobra", points: 1 },
          { text: "Na maioria das vezes sim", points: 2 },
          { text: "Às vezes ficamos sobrecarregados", points: 3 },
          { text: "Frequentemente perdemos leads por sobrecarga", points: 4 }
        ]
      }
    ],
    results: [
      {
        minScore: 5,
        maxScore: 8,
        title: "Atendimento Otimizado",
        description: "Seu atendimento já está em um bom nível! A IA pode ajudar a escalar ainda mais e liberar sua equipe para tarefas estratégicas.",
        color: "green",
        cta: "Quero Escalar Ainda Mais"
      },
      {
        minScore: 9,
        maxScore: 13,
        title: "Potencial Médio de Melhoria",
        description: "Você está perdendo oportunidades valiosas. Com IA, pode recuperar 40-60% dos leads perdidos e aumentar conversão significativamente.",
        color: "yellow",
        cta: "Quero Recuperar Essas Oportunidades"
      },
      {
        minScore: 14,
        maxScore: 20,
        title: "ALTO Potencial de Melhoria",
        description: "Atenção! Seu negócio está perdendo muitas oportunidades diariamente. IA pode triplicar sua taxa de conversão e recuperar 60-80% dos leads perdidos.",
        color: "red",
        cta: "Preciso Resolver Isso Agora"
      }
    ]
  }
};
